export const extractPlainText = (value) => {
  if (!value) return "";
  const doc = new DOMParser().parseFromString(value, "text/html");
  return doc.body.textContent || "";
};

export const extractNoteLinks = (value) => {
  const text = extractPlainText(value);
  const matches = text.match(/\[\[([^\]]+)\]\]/g) || [];
  return matches
    .map((m) => m.replace(/^\[\[|\]\]$/g, "").trim())
    .filter((m) => m.length > 0);
};

export const buildNoteIndex = (notes) => {
  const byId = new Map();
  const byTitle = new Map();
  notes.forEach((note) => {
    if (!note) return;
    byId.set(note.id, note);
    if (note.title) {
      byTitle.set(note.title.trim().toLowerCase(), note);
    }
  });
  return { byId, byTitle };
};

export const resolveLinkedNotes = (links, noteIndex) =>
  links
    .map((link) => noteIndex.byTitle.get(link.toLowerCase()))
    .filter(Boolean);

export const findBacklinks = (notes, targetTitle) => {
  if (!targetTitle) return [];
  const target = targetTitle.trim().toLowerCase();
  return notes.filter((note) => {
    const links = extractNoteLinks(note.content);
    return links.some((link) => link.toLowerCase() === target);
  });
};
